import { toTzInput, tzAbbr } from "@/lib/tz";

export const nextSlot = (tz) => {
  const d = new Date(Date.now() + 60 * 60 * 1000);
  d.setMinutes(d.getMinutes() < 30 ? 30 : 60, 0, 0);
  return toTzInput(d, tz);
};

const MODES = [
  ["scheduled", "Schedule a time"],
  ["now", "Call now"],
  ["none", "Don't call"],
];

// Phone-screen call choice inside the Invite Candidate form.
export default function InviteCallFields({ value, onChange, tz, hasPhone }) {
  return (
    <div className="mb-5" data-testid="invite-call-fields">
      <label className="text-xs text-slate-400 uppercase tracking-wider">Phone screen call</label>
      <div className="mt-1 grid grid-cols-3 gap-1 p-1 rounded-lg bg-[color:var(--bg-elev)] border border-[color:var(--bd-sub)]">
        {MODES.map(([k, label]) => (
          <button key={k} type="button" data-testid={`invite-call-${k}`} onClick={() => onChange({ call_mode: k })}
            className={`py-1.5 text-sm rounded-md transition-colors ${value.call_mode === k ? "bg-indigo-600 text-white" : "text-slate-500 hover:text-slate-200"}`}>
            {label}
          </button>
        ))}
      </div>
      {value.call_mode === "scheduled" && (
        <div className="mt-2">
          <input type="datetime-local" data-testid="invite-call-at" value={value.call_at_local} onChange={(e) => onChange({ call_at_local: e.target.value })}
            required={hasPhone} className="w-full px-3 py-2 rounded-lg bg-[color:var(--bg-elev)] border border-[color:var(--bd-sub)] focus:border-indigo-500 outline-none" />
          <div className="mt-1 text-xs text-slate-500" data-testid="invite-call-tz">Time in {tzAbbr(tz)} ({tz}) — the job location's timezone. The candidate gets an SMS and email with this time.</div>
        </div>
      )}
      {!hasPhone && value.call_mode !== "none" && <div className="mt-1 text-xs text-amber-500" data-testid="invite-call-nophone">Add a phone number above to call the candidate.</div>}
    </div>
  );
}
